module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span ng-if="::!layertreeCtrl.isRoot">{{::layertreeCtrl.node.name}}</span>\n<input\n  type="checkbox"\n  ng-if="::layertreeCtrl.node && !layertreeCtrl.node.children"\n  ng-model="layertreeCtrl.getSetActive"\n  ng-model-options="{getterSetter: true}"/>\n<ul ng-if="::layertreeCtrl.node.children">\n  <li\n    ng-repeat="node in ::layertreeCtrl.node.children"\n    ngeo-layertree="::node"\n    ngeo-layertree-notroot\n    ngeo-layertree-map="layertreeCtrl.map"\n    ngeo-layertree-nodelayerexpr="layertreeCtrl.nodelayerExpr"\n    ngeo-layertree-listenersexpr="layertreeCtrl.listenersExpr">\n  </li>\n</ul>\n';

}
return __p
}